import { useLanguage } from '../context/LanguageContext';
import { Mail, MapPin, Globe, Instagram } from 'lucide-react';

const LOGO_URL = "https://customer-assets.emergentagent.com/job_vocation-guide-1/artifacts/og76lhbc_logo%20neutre.%20.png";

export const Footer = () => {
  const { t, language } = useLanguage();

  return (
    <footer className="w-full py-8 px-6 md:px-12 bg-[#1D1D1D] text-white">
      <div className="max-w-7xl mx-auto">
        {/* Main footer content */}
        <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-6 mb-6">
          {/* Logo */}
          <div className="flex items-center gap-3">
            <img 
              src={LOGO_URL} 
              alt="Déclic Logo" 
              className="h-16 md:h-20 w-auto brightness-0 invert"
            />
          </div>
          
          {/* Contact Info */}
          <div className="flex flex-col md:flex-row gap-4 md:gap-8 text-sm text-gray-300">
            <div className="flex items-center gap-2">
              <Mail className="w-4 h-4 text-[#A4187A]" />
              <a href="mailto:info@declicbelgium.be" className="hover:text-white transition-colors">
                info@declicbelgium.be
              </a>
            </div>
            <div className="flex items-center gap-2">
              <MapPin className="w-4 h-4 text-[#A4187A]" />
              <span>Rue Belliard 143, 1040 Etterbeek</span>
            </div>
            <div className="flex items-center gap-2">
              <Globe className="w-4 h-4 text-[#A4187A]" />
              <a href="https://www.declicbelgium.be" target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors">
                www.declicbelgium.be
              </a>
            </div>
            <div className="flex items-center gap-2">
              <Instagram className="w-4 h-4 text-[#E4405F]" />
              <a href="https://www.instagram.com/declicbelgium" target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors">
                @declicbelgium
              </a>
            </div>
          </div>
        </div>
        
        {/* Bottom line */}
        <div className="border-t border-gray-700 pt-4 flex flex-col md:flex-row items-center justify-between gap-2">
          <p className="text-sm text-gray-400">
            © {new Date().getFullYear()} Déclic asbl - {language === 'fr' ? 'Tous droits réservés' : 'Alle rechten voorbehouden'}
          </p>
          <p className="text-sm text-gray-400 text-center md:text-right">
            {t('inspireTagline')}
          </p>
        </div>
      </div>
    </footer>
  );
};
